import { configureStore } from '@reduxjs/toolkit'
import authReducer from '../features/auth/authSlice';
import userReducer from '../features/user/userSlice';
import cartReducer from '../features/cart/cartSlice';
import productsReducer from '../features/products/productsSlice';
import addressReducer from '../features/address/addressSlice';
import nurseryReducer from '../features/nursery/nurserySlice';
import orderReducer from '../features/order/orderSlice';
import checkoutReducer from '../features/checkout/checkoutSlice';
import nurseryPublicStoreSlice  from '../features/nursery/nurseryPublicStoreSlice';
import adminReducer from '../features/admin/adminSlice';
import categoryReducer from '../features/category/categorySlice';
import saveForLaterReducer from '../features/cart/saveForLaterSlice';

export default configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        cart: cartReducer,
        products: productsReducer,
        address: addressReducer,
        nursery: nurseryReducer,
        nurseryPublicStore: nurseryPublicStoreSlice,
        checkout: checkoutReducer,
        order: orderReducer,
        admin: adminReducer,
        category: categoryReducer,
        saveForLater: saveForLaterReducer,
    },
});